import {
  Group,
  InputLabel,
  Select,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useMemo, useRef, useState } from "react";
import { getCountries } from "react-phone-number-input";
import Input from "react-phone-number-input/input";
import { getCountryCallingCode } from "react-phone-number-input";
import { useLanguage } from "../../stores/LanguageStore";

const PhoneNumberInput = ({
  defaultValue,
  defaultCountry,
  name,
  label,
  required,
  id,
  error,
  placeholder,
  size,
  withCountrySelector = true,
  ...props
}) => {
  const lang = useLanguage((s) => s.language);
  const ref = useRef();
  const [value, setValue] = useState(defaultValue);
  const [country, setCountry] = useState(defaultCountry);

  const countryOptions = useMemo(() => {
    return getCountries().map((c) => ({
      value: c,
      label: `${c} +${getCountryCallingCode(c)}`,
    }));
  }, []);

  const onCountryChange = (c) => {
    setCountry(c);
    setValue(null);
    ref.current.focus();
  };

  return (
    <Stack gap={"xs"} {...props}>
      <InputLabel required={required} size={size} mb={-10}>
        {label}
      </InputLabel>
      <Group gap={0} wrap="nowrap">
        {withCountrySelector && (
          <Select
            data={countryOptions}
            value={country}
            name={name + "_country"}
            autoComplete="off"
            onChange={onCountryChange}
            rightSectionWidth={0}
            miw={64}
            w={size === "lg" ? 142 : 132}
            styles={{
              input: {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
              },
              option: {
                padding: 0,
              },
            }}
            renderOption={(item) => (
              <Group
                bg={item.checked ? "var(--mantine-primary-color-0)" : undefined}
                flex={"1 1 auto"}
                w={0}
                h={"100%"}
                p={8}
                wrap="nowrap"
                gap={8}
              >
                <Text>{item.option.value}</Text>

                {/* <Flag code={item.option.value} width={20} /> */}
                <Text truncate="end" size="sm" fw={600}>
                  +{getCountryCallingCode(item.option.value)}
                </Text>
              </Group>
            )}
            comboboxProps={{ width: 100 }}
            searchable
            error={error}
            size={size}
            onClick={(e) => {
              e.target.select();
            }}
          />
        )}
        <Input
          ref={ref}
          country={country}
          inputComponent={TextInput}
          autoComplete="mobile_phone phone"
          onChange={(v) => setValue(v)}
          value={value}
          required={required}
          placeholder={"0XXXXXXXX"}
          size={size}
          w={"100%"}
          styles={{
            input: {
              borderTopLeftRadius: withCountrySelector ? 0 : 4,
              borderBottomLeftRadius: withCountrySelector ? 0 : 4,
              borderLeftWidth: withCountrySelector ? 0 : 1,
            },
          }}
          name={name}
          error={error}
          id={id}
        />
      </Group>
      {/* <Text size={"xs"}>*{lang.profile.with_zero}</Text> */}
    </Stack>
  );
};

export default PhoneNumberInput;
